import { useCallback } from 'react';
import { useSharedTiles } from '../../../../rocco/src/ui/tile-shared/hooks/use-shared-tiles';
import { getSourceSection } from '../../utils/get-source-section';
import { useTracker } from '../../../../tracker';

interface SearchTrackingConfig {
    isSearchPage?: boolean;
}

export const useSearchTracking = (config: SearchTrackingConfig) => {
    const tracker = useTracker();
    const { isSearchPage = true } = config;

    const onTileClick = useCallback(
        (
            targetRef: React.RefObject<HTMLElement>,
            itemID?: number,
            professionalID?: number
        ) => {
            tracker.log('SearchTileClick', {
                url: new URL(window.location.href),
                data: {
                    LibraryItemID: itemID,
                    ProfessionalID: professionalID,
                },
            });
        },
        [tracker]
    );

    const onPerformSearch = useCallback(
        (query: string) => {
            tracker.log('PerformSearch', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: query,
                },
            });
        },
        [tracker]
    );

    const onSearchSuggestionClick = useCallback(
        (query: string) => {
            tracker.log('SearchSuggestionClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: query,
                },
            });
        },
        [tracker]
    );

    const onRecentSearchClick = useCallback(
        (query: string) => {
            tracker.log('RecentSearchClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: query,
                },
            });
        },
        [tracker]
    );

    const onSuggestedCategoryClick = useCallback(
        (title: string) => {
            tracker.log('SearchSuggestedCategoryClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: title,
                },
            });
        },
        [tracker]
    );

    const onSearchTrendingClick = useCallback(
        (title: string) => {
            tracker.log('SearchTrendingClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: title,
                },
            });
        },
        [tracker]
    );

    const onTileMediaSliderSlideChange = useCallback(
        (direction: 'CarouselPrev' | 'CarouselNext', itemID?: number) => {
            const sectionSource = getSourceSection();
            tracker.log(direction, {
                url: new URL(window.location.href),
                data: {
                    ExtraData: {
                        source: sectionSource,
                        LibraryItemID: itemID,
                    },
                },
            });
        },
        [tracker]
    );

    // add tracking to rocco tiles
    useSharedTiles({
        trackingConfig: isSearchPage
            ? {
                  onClick: onTileClick,
                  onTileMediaSliderSlideChange,
              }
            : undefined,
    });

    return {
        onPerformSearch,
        onSearchSuggestionClick,
        onRecentSearchClick,
        onSuggestedCategoryClick,
        onSearchTrendingClick,
    };
};
